import { CustomerService } from '@/modules/customer/customer-service';
import RelationToOneField from '@/shared/fields/relation-to-one-field';
import RelationToManyField from '@/shared/fields/relation-to-many-field';
import Permissions from '@/security/permissions';

export class CustomerField {
  static relationToOne(name, label, options) {
    return new RelationToOneField(
      name,
      label,
      '/customer',
      Permissions.values.customerRead,
      CustomerService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.name,
        };
      },
      options,
    );
  }

  static relationToMany(name, label, options) {
    return new RelationToManyField(
      name,
      label,
      '/customer',
      Permissions.values.customerRead,
      CustomerService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.name,
        };
      },
      options,
    );
  }
}
